import { chain as flatMap } from 'ramda'
import { Stack } from '@material-ui/core'
import Tags from 'src/components/Tags'
import YesNoAnyButtonGroup from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/YesNoAnyButtonGroup'
import { styled } from '@mui/material/styles'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

const toTagOption = (value) => {
  switch (value) {
    case 'Heterozygote':
    case 'Homozygote':
      return { label: value, value, hidden: true }
    default:
      return { label: value, value }
  }
}

function isSubset(set, iterable) {
  const iterableSet = new Set(iterable)
  for (const elem of set) {
    if (!iterableSet.has(elem)) {
      return false
    }
  }
  return true
}

const HOMOZYGOTE_GT_OPTIONS = new Set([
  '1',
  //
  '1/1',
  '1|1',
  //
  '2|2',
  '2/2',
])

const HETEROZYGOTE_GT_OPTIONS = new Set([
  '0/1',
  '1/0',
  //
  '0|1',
  '1|0',
  //
  '0|2',
  '0/2',
  '2|0',
  '2/0',
  //
  '1|2',
  '1/2',
  '2|1',
  '2/1',
])

const GT_OPTIONS = [...HETEROZYGOTE_GT_OPTIONS, ...HOMOZYGOTE_GT_OPTIONS].map(toTagOption)

// TODO: Refactor
function GenotypeFilter(props) {
  const gtFilterEvent = Array.isArray(props.gtFilterEvent) ? props.gtFilterEvent : []
  const hasAllHeterozygoteOptions = isSubset(HETEROZYGOTE_GT_OPTIONS, gtFilterEvent)
  const hasAllHomozygoteOptions = isSubset(HOMOZYGOTE_GT_OPTIONS, gtFilterEvent)

  const getTagOptions = () => {
    let tags = []
    if (hasAllHeterozygoteOptions && hasAllHomozygoteOptions) {
      tags = ['Homozygote', 'Heterozygote']
    } else if (hasAllHeterozygoteOptions) {
      const rest = gtFilterEvent.filter((o) => !HETEROZYGOTE_GT_OPTIONS.has(o))
      tags = ['Heterozygote', ...rest]
    } else if (hasAllHomozygoteOptions) {
      const rest = gtFilterEvent.filter((o) => !HOMOZYGOTE_GT_OPTIONS.has(o))
      tags = ['Homozygote', ...rest]
    } else {
      tags = gtFilterEvent
    }

    return tags.map(toTagOption)
  }

  const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButton-root': {
      textTransform: 'none',
      minWidth: '80px',
      borderRadius: '20px',
      padding: '6px 16px',
      '&.Mui-selected': {
        backgroundColor: theme.palette.grey[300], // Changed from grey[200] to grey[300]
        color: theme.palette.text.primary,
        '&:hover': {
          backgroundColor: theme.palette.grey[400], // Changed from grey[300] to grey[400]
        },
      },
    },
  }))

  const getCategory = () => {
    if (gtFilterEvent.includes('Compound') && gtFilterEvent.length === 1) {
      return 'COMPOUND'
    } else if (hasAllHeterozygoteOptions && hasAllHomozygoteOptions) {
      return 'ANY'
    } else if (hasAllHeterozygoteOptions) {
      return 'NO'
    } else if (hasAllHomozygoteOptions) {
      return 'YES'
    } else {
      return 'ANY'
    }
  }

  const handleCategoryChange = (_, newCategory) => {
    if (newCategory === null) return // Prevent deselection

    switch (newCategory) {
      case 'ANY':
        props.setGtFilterEvent([...HOMOZYGOTE_GT_OPTIONS, ...HETEROZYGOTE_GT_OPTIONS])
        break
      case 'YES': // Homozygote
        props.setGtFilterEvent([...HOMOZYGOTE_GT_OPTIONS])
        break
      case 'NO': // Heterozygote
        props.setGtFilterEvent([...HETEROZYGOTE_GT_OPTIONS])
        break
      case 'COMPOUND':
        props.setGtFilterEvent(['Compound'])
        break
      default:
      // do nothing
    }
  }

  const handleGtTagChange = (newData) => {
    const newValues = flatMap((option) => {
      switch (option.value) {
        case 'Heterozygote':
          return [...HETEROZYGOTE_GT_OPTIONS]
        case 'Homozygote':
          return [...HOMOZYGOTE_GT_OPTIONS]
        default:
          return option.value
      }
    }, newData)
    props.setGtFilterEvent(newValues)
    // if newValues includes something other than Compound, remove Compound
    if (newValues.length > 1 || !newValues.includes('Compound')) {
      props.setGtFilterEvent(newValues.filter((value) => value !== 'Compound'))
    }
  }

  return (
    <Stack direction="column" spacing={2}>
      <StyledToggleButtonGroup
        value={getCategory()}
        exclusive
        onChange={handleCategoryChange}
        aria-label="genotype category"
        fullWidth
      >
        <ToggleButton value="ANY">All</ToggleButton>
        <ToggleButton value="YES">Homozygote</ToggleButton>
        <ToggleButton value="NO">Heterozygote</ToggleButton>
        <ToggleButton value="COMPOUND">
          Compound
          <br />
          Heterozygote
        </ToggleButton>
      </StyledToggleButtonGroup>
      <Tags
        title="Genotype"
        options={GT_OPTIONS.filter(({ value }) => !gtFilterEvent.includes(value))}
        value={getTagOptions()}
        onChange={handleGtTagChange}
      />
    </Stack>
  )
}

export default GenotypeFilter
